import { formatCardNumber } from "@/common/utils/formatters";
import { cardStatusTranslation } from "../../constants/cardStatusTranslation.constant";
import { CardData } from "../../types/card.type";
import { cardTypeTranslation } from "@/common/constants/cards.constant";
interface CardItemProps {
  index: number;
  card: CardData;
}

const CardItem = ({ index, card }: CardItemProps) => {
  return (
    <div className="flex gap-3 bg-white-200 w-full p-4 rounded">
      <div className="text-xs">
        {index}
      </div>

      <div className="flex flex-col gap-3 grow">
        <div className="flex gap-3 items-end">
          <div>
            <p className="text-xs font-light italic">Status</p>
            <p className="text-sm">{card.status ? cardStatusTranslation[card.status]: ''}</p>
          </div>

          <div>
            <p className="text-xs font-light italic">Número do cartão</p>
            <p className="text-sm">{formatCardNumber(card.last_four_digits)}</p>
          </div>
        </div>

        <div className="flex gap-3 items-end">
          <div>
            <p className="text-xs font-light italic">Tipo</p>
            <p className="text-sm">{cardTypeTranslation[card.type]}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardItem;
